export interface LocationOption {
    label: string;
    value: string;
}

/**
 * Normalise ID to string for type-safe comparison.
 * GraphQL IDs can be string or number; form/Select values are always strings.
 */
export function toComparableId(id: string | number | null | undefined): string {
    if (id == null) return '';
    return String(id);
}

/**
 * Returns the event ID for the calendar link when multiple events are selected.
 * Uses the coming active event closest to now (first in locationOptions, which are
 * sorted by nearest upcoming date).
 */
export function getPrimaryEventId(
    eventId: string | null,
    locationOptions: LocationOption[],
): string | null {
    if (!eventId || !locationOptions.length) return null;
    const selectedIds = eventId
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
    if (selectedIds.length === 0) return null;
    const primary = locationOptions.find((opt) =>
        selectedIds.includes(opt.value),
    );
    return primary?.value ?? selectedIds[0] ?? null;
}
